var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-type-template',{attrs:{"type":'Destination',"action":_vm.action,"items":_vm.items,"grid":"detail1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }